import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import ProductCard from '@nmx/template/dist/componentLibrary/modules/ProductCard';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// styles
import {
  ColStyled,
  RowStyled,
  SectionContainerStyled,
} from './styles';

const baseId = 'product-callout-long-term-care-planning';

const ITEMS = [
  {
    cardId: 'get-care-quickly',
    cardHeading: (
      <>Get quality <WidowBlock>care quickly</WidowBlock></>
    ),
    contentBlock:
      (
        <Typography disableBottomPadding>
          If something happens, having coverage means you&#39;ll have funds ready when you need them.
        </Typography>
      ),
  },
  {
    cardId: 'choose-where',
    cardHeading: (
      <>Choose where you <WidowBlock>get care</WidowBlock></>
    ),
    contentBlock:
      (
        <Typography disableBottomPadding>
          From at&#45;home to a good facility, having a long&#45;term care plan in place can help you afford it.
        </Typography>
      ),
  },
  {
    cardId: 'nest-egg',
    cardHeading: (
      <>Safeguard your <WidowBlock>nest egg</WidowBlock></>
    ),
    contentBlock:
      (
        <Typography disableBottomPadding>
          Having a plan for long&#45;term care can help make sure you won&#39;t lose a lifetime of savings.
        </Typography>
      ),
  },
  {
    cardId: 'preserve-assets',
    cardHeading: 'Preserve your assets',
    contentBlock:
      (
        <Typography disableBottomPadding>
          Long&#45;term care planning can help keep your financial legacy intact for your family, friends, or charity.
        </Typography>
      ),
  },
  {
    cardId: 'loved-ones',
    cardHeading: (
      <>Put loved ones <WidowBlock>at ease</WidowBlock></>
    ),
    contentBlock:
      (
        <Typography disableBottomPadding>
          Those closest to you can focus on support rather than the physical, emotional, and financial burdens of your care.
        </Typography>
      ),
  },
];

export default () => (
  <SectionContainerStyled
    id='long-term-care-planning-product-callout-grouping-1'
    moduleName='product-callout-grouping-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col
        small={10}
        large={7}>
        <Typography
          align='center'
          component='h2'
          nextElement='graphic'>
          Reasons to plan for your <WidowBlock>long&#45;term care</WidowBlock>
        </Typography>
      </Col>
    </Row>
    <RowStyled align='left'>
      {ITEMS.map((item) => (
        <ColStyled
          key={`col-${item.cardId}`}
          medium={6}
          large={4}>
          <ProductCard
            cardId={`${baseId}-${item.cardId}`}
            cardHeading={item.cardHeading}
            contentBlock={item.contentBlock}
            backgroundVariant='lightB'
            withHeadingAccent
          />
        </ColStyled>
      ))}
    </RowStyled>
  </SectionContainerStyled>
);
